module.exports = __webpack_public_path__ + "img/sin_imagen_180.26e9b75c.jpg";